export function isSameOrigin(url: string) {
  // Create an anchor element
  const anchor = document.createElement("a");
  anchor.href = url;

  // Get the origin of the current page
  const currentOrigin = window.location.origin;

  // Compare the origins
  return anchor.origin === currentOrigin;
}
